import { IQuote, IWidgetConfig } from "../types";

export const getLocalStorageVariables = () => {
  const loanType = localStorage.getItem("loanType") as string;
  const partnerId = localStorage.getItem("externalPartnerId") as string;
  const sourceUrl = localStorage.getItem("sourceUrl") as string;
  const source = localStorage.getItem("source") as string;
  const targetSystem = localStorage.getItem("targetSystem") as string;
  const countryCode = localStorage.getItem("countryCode") as string;
  const loanPurpose = localStorage.getItem("loanPurpose") as string;
  return {
    partnerId,
    sourceUrl,
    loanType,
    source,
    targetSystem,
    countryCode,
    loanPurpose,
  };
};

export const setCssVariables = (p: string, s: string, t: string, q: string) => {
  document.documentElement.style.setProperty("--widgetPrimary", p);
  document.documentElement.style.setProperty("--widgetSecondary", s);
  document.documentElement.style.setProperty("--widgetTertiary", t);
  document.documentElement.style.setProperty("--widgetQuaternary", q);
};

export const getInitialState = (w: IWidgetConfig) => {
  const {
    loanType,
    partnerId,
    sourceUrl,
    source,
    targetSystem,
    countryCode,
    loanPurpose,
  } = getLocalStorageVariables();

  let newQuote = {
    externalPartnerId: partnerId,
    sourceUrl: sourceUrl,
    source: source,
    targetSystem: targetSystem,
    type: w.loanType || loanType,
    term: w?.questions.find((q) => q.mapping === "term")
      ?.defaultValue as number,
    usage:
      w?.questions.find((q) => q.mapping === "usage" && q.defaultValue)
        ?.defaultValue ?? "CONSUMER", // Provide a default string value
    amount:
      w?.questions.find((q) => q.mapping === "amount" && q.defaultValue)
        ?.defaultValue ?? 10000, // Provide a default numerical value
    countryCode: countryCode || "AU",
    loanPurpose: loanPurpose || "",
  };
  return newQuote as IQuote;
};
